import type { SupportQueue, TicketDetail, TicketListRow, TicketMessage } from '@elutide/shared';

export interface Page<T> {
  items: T[];
  next_cursor: string | null;
  total_estimate: number | null;
}

export interface TicketItem {
  id: number;
  order_item_id: number | null;
  product_name: string | null;
  sku: string | null;
  issue_type: string;
  qty_affected: number;
  item_note: string | null;
}

export interface TicketWorkspaceData extends TicketDetail {
  items: TicketItem[];
  draft: { ticket_id: number; body: string; updated_at: string } | null;
}

export type QueueCounts = Record<SupportQueue, number> & { handoff_open: boolean };

export interface SupportMacroRow {
  macro_id: string;
  name: string;
  shortcut: string | null;
  body_email: string;
  body_sms: string | null;
  set_status: string | null;
  version: number;
  is_active: boolean;
}

export interface HandoffRow {
  handoff_id: number;
  status: string;
  customer_email: string | null;
  customer_first: string | null;
  last_customer_msg_at: string | null;
  created_at: string;
  ticket_id: number | null;
  auto_ticket_in_seconds: number | null;
}

export interface HandoffMessage {
  message_id: number;
  sender: string;
  body: string;
  created_at: string;
}

export interface BulkPreview {
  count: number;
  cap: number;
  by_status: Record<string, number>;
  notify: boolean;
  outbound: boolean;
  undo_seconds: number;
  warnings: string[];
}

export type { SupportQueue, TicketListRow, TicketMessage };

export const QUEUE_LABELS: Record<SupportQueue, string> = {
  needs_reply: 'Needs reply',
  waiting_on_customer: 'Waiting on customer',
  live_handoff: 'Live handoff',
  unassigned: 'Unassigned',
  resolved_7d: 'Resolved 7d',
  all: 'All',
};
